import { SVGProps } from 'react';

const ArrowPrevious = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
    data-palette="ArrowPrevious">
    <path
      fill="#E1E1E2"
      d="M15.75 8.25H6.622l4.193-4.192L9.75 3l-6 6 6 6 1.057-1.057L6.622 9.75h9.128v-1.5Z"
    />
  </svg>
);
export default ArrowPrevious;
